var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header'),_c('breadcrumb',{staticClass:"pt-5 mt-5 mb-3"}),_c('messages'),(_vm.isStarted)?_c('router-view',{staticClass:"container-fluid pb-4",scopedSlots:_vm._u([{key:"default",fn:function({ Component }){return [_c(Component,{tag:"component"})]}}],null,false,4222730052)}):_c('Loading'),_c('Footer',{staticClass:"mt-3"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }